const Response = {
  HTTP_BAD_REQUEST: 400,
  HTTP_UNPROCESSABLE_ENTITY: 422,
  HTTP_UNAUTHORIZED: 401,
};

export default Response;
